module.exports = __webpack_public_path__ + "img/galeria-video-4.3f3c6fec.png";